import { baseCommand } from "./basecommand";

type sceenextrastypename = "extras";

type sceenextrasdatatype = any;

type pscommand<T> = {
    "type": T extends sceenextrastypename ? T : never;
    "data": T extends sceenextrastypename ? sceenextrasdatatype : never;
};

export type sceneextrasCommand = pscommand<sceenextrastypename>;

export class sceneextras extends baseCommand {
    public type: sceenextrastypename = "extras";

    constructor(private extras: any) {
        super();
    }

    public object(): sceneextrasCommand {
        return {
            "type" : this.type,
            "data" : this.extras
        }
    }
}
